<template>
  <b-modal :active="value" @close="hide" :width="850" scroll="keep">
    <div class="card">
      <div class="card-content">
        <h2 class="title is-4 has-text-info mb-6">
          <font-awesome-icon icon="chart-column" class="mr-2"/>
          Trends &amp; Aggregations
        </h2>
        <div class="chart-canvas container block">

          <dow-aggregations :agg="aggs.dayOfWeek" />
          <hr>
          
          <hour-aggregations :agg="aggs.hourOfDay" />
          <hr>

          <subject-aggregations :agg="aggs.deviceId" @filter="hide"/>
          <hr>

          <group-aggregations :agg="aggs.groups" @filter="hide"/>
          <hr>

          <policy-aggregations :agg="aggs.policySets" @filter="hide"/>
          <hr>

          <div class="row">
            <div class="columns">
              <div class="column">
                <message-aggregations :agg="aggs.message" @filter="hide"/>
              </div>
              <div class="column content">
                <h3 class="subtitle is-5">Mobile events</h3>
                <ul>
                  <li v-for="a in aggs.mobileRules" :key="a.key">{{ a.key }}: {{ a.count.toLocaleString() }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import SubjectAggregations from './SubjectAgg.vue';
import GroupAggregations from './GroupAgg.vue';
import DowAggregations from './DowAgg.vue';
import HourAggregations from './HourAgg.vue';
import PolicyAggregations from './PolicyAgg.vue';
import MessageAggregations from './MessageAgg.vue';

export default {
  components: {
    SubjectAggregations,
    DowAggregations,
    HourAggregations,
    GroupAggregations,
    PolicyAggregations,
    MessageAggregations
  },
  emits: ["input"],
  props: {
    value: Boolean,
    aggs: Object,
  },
  methods: {
    hide () {
      this.$emit('input', false)
    },
  }
};
</script>